import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "countdown-container"
};
const _hoisted_2 = {
  class: "time-display"
};
const _hoisted_3 = {
  class: "time-unit"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "width": "220px",
    "align-items": "center"
  }
};
const _hoisted_5 = {
  class: "pt10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createTextVNode(" 预计结束时间： ")), _createElementVNode("span", _hoisted_3, _toDisplayString($props.initialTime), 1)]), _createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("span", {
    style: {
      "font-size": "14px"
    }
  }, "速度：", -1)), _createVNode(_component_el_button, {
    type: $props.countdown == 1000 ? 'primary' : '',
    circle: "",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('set-time', 1000)),
    style: {
      "margin-left": "12px"
    }
  }, {
    default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" x1 ")])),
    _: 1
  }, 8, ["type"]), _createVNode(_component_el_button, {
    type: $props.countdown == 500 ? 'primary' : '',
    circle: "",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('set-time', 500))
  }, {
    default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" x2 ")])),
    _: 1
  }, 8, ["type"]), _createVNode(_component_el_button, {
    type: $props.countdown == 250 ? 'primary' : '',
    circle: "",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('set-time', 250))
  }, {
    default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" x4 ")])),
    _: 1
  }, 8, ["type"]), _createVNode(_component_el_button, {
    type: $props.countdown == 125 ? 'primary' : '',
    circle: "",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('set-time', 125))
  }, {
    default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" x8 ")])),
    _: 1
  }, 8, ["type"])]), _createElementVNode("div", _hoisted_5, [_cache[16] || (_cache[16] = _createElementVNode("span", {
    style: {
      "font-size": "14px"
    }
  }, "播放状态：", -1)), _createVNode(_component_el_tag, {
    type: $props.show ? 'info' : 'warning',
    effect: $props.show ? 'light' : 'dark',
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('status', 'Pause'))
  }, {
    default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("暂停")])),
    _: 1
  }, 8, ["type", "effect"]), _createVNode(_component_el_tag, {
    type: $props.show ? 'warning' : 'info',
    effect: $props.show ? 'dark' : 'light',
    onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('status', 'Play'))
  }, {
    default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("继续")])),
    _: 1
  }, 8, ["type", "effect"]), _createVNode(_component_el_tag, {
    type: "danger",
    effect: "dark",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.$emit('status', 'Close'))
  }, {
    default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("关闭")])),
    _: 1
  })])]);
}